import { isNil } from 'lodash-es';

/**
 * 將數字轉換為千分位格式，小數最多取至第 2 位
 * @param num - 要格式化的數字
 * @returns 格式化後的字串，如 "10,000" 或空字串
 * @example withDigitGrouping(10000) // "10,000"
 * @example withDigitGrouping(9.991) // "9.99"
 */
export function withDigitGrouping (num: number | string) {
  if (isNil(num)) { return ''; }

  const number = Number(num);
  if (isNaN(number)) { return ''; }

  // 小數最多取至第二位
  return number.toLocaleString('en-US', { maximumFractionDigits: 2 });
}
